module.exports = __webpack_public_path__ + "static/Logo-efbceb3ee67003c988d398645594b75b.svg";